// NEW: UI_REVAMP
import { Button, Flex, Spinner, Square, Text } from '@chakra-ui/react';
import dayjs from 'dayjs';
import { ReactComponent as BetList } from '../../assets/svg/list.svg';
import { ReactComponent as LuckyPick } from '../../assets/svg/lucky.svg';
import SelectionButton from '../button/SelectionButton';

const BET_TYPE = [
	{
		label: 'Straight',
		value: false,
		color: '#FD4D01',
		bgGradient: 'linear-gradient(180deg, #FCE007 0%, #F99D20 100%)',
	},
	{
		label: 'Ramble',
		value: true,
		color: 'white',
		bgGradient: 'linear-gradient(180deg, #D81985 0%, #E81A1E 100%)',
	},
];

const SiteOptionContent = ({
	list,
	showBetList,
	setShowBetList,
	getDraw,
	time,
	timeBtnId,
	serverTime,
	setTime,
	setTimeBtnId,
	setTimeName,
	handleLucky,
	activeBetType,
	setActiveBetType,
}) => {
	if (getDraw.isLoading)
		return (
			<Flex justifyContent='center' h='100px' alignItems='center'>
				<Spinner size='xl' thickness='3px' />
			</Flex>
		);

	return (
		<Flex flexDirection='column' gap={1} px={1} py={2} maxH='100px'>
			{/* Draw Time Selection */}
			<Flex gap={1}>
				<Button
					onClick={() => setShowBetList(!showBetList)}
					bg={showBetList ? 'linear-gradient(180deg, #FCE007 0%, #F99D20 100%)' : 'white'}
					w='40px'
					h='40px'
					borderRadius={8}
					border={`1px solid ${showBetList ? '#FCE007' : '#EAE9EF'}`}
					display='flex'
					justifyContent='center'
					alignItems='center'
					p={0}
					_hover={{
						bg: showBetList ? 'linear-gradient(180deg, #FCE007 0%, #F99D20 100%)' : 'white',
						border: `1px solid ${showBetList ? '#EAE9EF' : '#FCE007'}`,
					}}
				>
					<BetList size={24} color={showBetList ? 'rgba(253, 77, 1, 1)' : 'rgba(17, 17, 17, 1)'} />
				</Button>
				{getDraw.data?.map((item) => {
					const formatMYT = (time) => dayjs.utc(time).tz('Asia/Kuala_Lumpur').format('h:mm A');
					const isDrawSelected = time === formatMYT(item.drawTime) && timeBtnId === item.id;
					const now = dayjs(serverTime);
					const start = dayjs(item.startTime);
					const end = dayjs(item.drawTime);

					const isDisabled =
						item.cancelled ||
						now.isBefore(start) ||
						now.isAfter(end) ||
						(list.length > 0 && list.some((bet) => bet.drawId !== item.id));

					let state = 'default';

					if (isDisabled) {
						state = 'disabled';
					} else if (isDrawSelected) {
						state = 'selected';
					} else {
						state = 'default';
					}

					return (
						<SelectionButton
							variant='timePick'
							key={item.id}
							status={state}
							onClick={() => {
								setTime(dayjs(item.drawTime).format('h:mm A'));
								setTimeBtnId(item.id);
								setTimeName(item.name);
							}}
						>
							<Text fontSize='13px' fontWeight='600'>
								{item.name}
							</Text>
						</SelectionButton>
					);
				})}
			</Flex>

			{/* Bet Type Selection */}
			<Flex gap={1}>
				<Button
					onClick={handleLucky}
					bg='white'
					w='40px'
					h='40px'
					borderRadius={8}
					border='1px solid #EAE9EF'
					display='flex'
					justifyContent='center'
					alignItems='center'
					p={0}
					_hover={{ bg: 'white' }}
					isDisabled={activeBetType === null || time === ''}
				>
					<LuckyPick size={24} opacity={activeBetType === null || time === '' ? 0.5 : 1} />
				</Button>
				{BET_TYPE.map((option) => {
					const isSelected = activeBetType === option.value;
					const shortForm = option.label.charAt(0);
					let state = 'default';
					const isDisabled = time === '';

					if (isDisabled) {
						state = 'disabled';
					} else if (isSelected) {
						state = 'selected';
					} else {
						state = 'default';
					}
					return (
						<SelectionButton
							key={option.label}
							variant='betTypePick'
							status={state}
							onClick={() => setActiveBetType(option.value)}
						>
							<Square
								size='24px'
								bgGradient={option.bgGradient}
								color={option.color}
								fontSize='14px'
								borderRadius='4px'
								fontWeight='bold'
								opacity={isDisabled ? 0.5 : 1}
							>
								{shortForm}
							</Square>
							<Text
								as='span'
								fontSize='13px'
								fontWeight='600'
								color='inherit'
								opacity={isDisabled ? 0.5 : 1}
							>
								{option.label}
							</Text>
						</SelectionButton>
					);
				})}
			</Flex>
		</Flex>
	);
};

export default SiteOptionContent;
